import { ReturnAppSettings } from "@redotech/redo-customer-portal-shared/settings";
import { getResource } from "@redotech/redo-model/localization/resource";

import { CurrencyContext } from "@redotech/redo-web/currency";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useContext } from "react";

import { getTeamCustomLayout } from "./instant-exchange-disclaimer-helper";

export const InstantExchangeDisclaimer = memo(
  function InstantExchangeDisclaimer({
    settings,
    exchangeAmount,
  }: {
    settings: ReturnAppSettings;
    exchangeAmount: number;
  }) {
    const copyResource = getResource({
      variant: "return",
      overrides: settings.resourceOverride,
    });

    const { formatCurrency, formatCurrencyFromUSD } =
      useContext(CurrencyContext);

    let holdAmount = 0;
    let currencyFormatter = formatCurrency;

    switch (settings.exchanges.instantHoldAmount) {
      case "none":
        holdAmount = 0;
        break;
      case "one_dollar":
        holdAmount = 1;
        currencyFormatter = formatCurrencyFromUSD;
        break;
      case "full_cost":
        holdAmount = exchangeAmount;
        break;
    }

    const isCustomLayout = getTeamCustomLayout(settings.storeUrl);

    return (
      <Flex dir="column">
        <Text fontSize="xs">
          {holdAmount ? (
            <>
              A hold of <b>{currencyFormatter(holdAmount)}</b> will be placed on
              your card. If your items are dropped off at the carrier within{" "}
              {settings.exchanges.instantExpirationDays} days, the hold will be
              removed. Otherwise, you will be charged{" "}
              <b>{formatCurrency(exchangeAmount)}</b> for your new items.
            </>
          ) : (
            <>
              If you do not drop off your old items within{" "}
              {settings.exchanges.instantExpirationDays} days, you will be
              charged <b>{formatCurrency(exchangeAmount)}</b> for your new
              items.
            </>
          )}
        </Text>

        {isCustomLayout && (
          <Text fontSize="xs">
            {copyResource.INSTANT_EXCHANGE_DISCLAIMER_SUBTEXT}
          </Text>
        )}
      </Flex>
    );
  },
);
